import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import { useIntl } from 'react-intl';
import { connect } from 'react-redux';

import { showModal } from '../../../actions';

import { userCan } from '../../../helpers/Auth';
import { getSetting } from '../../../helpers/Settings';

import ErrorBoundary from '../../ErrorBoundary';

const FileHeaderShareButton = ({
  file,
  shareUuid,
  handleChangeAccess,
  handleShareFile,
}) => {
  const intl = useIntl();

  return (
    <ErrorBoundary invisible={true}>
      {(!shareUuid && userCan('file.share', file) && (!file.archived || getSetting('cs1'))) ? (
        <Button
          color="link"
          id={`FileActionShare-${file.uuid}`}
          onClick={(e) => {
            e.preventDefault();
            if (userCan('file.change_access', file)) {
              handleChangeAccess(file.uuid);
            } else {
              handleShareFile(file);
            }
          }}
        >
          <i className="fal fa-share-alt" />
          <span>
            {userCan('file.change_access', file) ? (
              intl.formatMessage({ defaultMessage: 'Access & Share' })
            ) : (
              intl.formatMessage({ defaultMessage: 'Share a link' })
            )}
          </span>
        </Button>
      ) : (
        <>
          {(!shareUuid && userCan('file.change_access', file)) && (
            <Button
              color="link"
              id={`FileActionShare-${file.uuid}`}
              onClick={(e) => {
                e.preventDefault();
                handleChangeAccess(file.uuid);
              }}
            >
              <i className="fal fa-share-alt" />
              {intl.formatMessage({ defaultMessage: 'Access & Share' })}
            </Button>
          )}
        </>
      )}
    </ErrorBoundary>
  );
};

const mapDispatchToProps = (dispatch) => ({
  handleShareFile: (file) => {
    dispatch(showModal('ShareModal', {
      className: 'modal-share modal-share-file',
      files: [file],
    }));
  },
  handleChangeAccess: (file) => {
    dispatch(showModal('AccessModal', {
      className: 'modal-access modal-file-access',
      files: [file],
    }));
  },
});

FileHeaderShareButton.propTypes = {
  file: PropTypes.object.isRequired,
  shareUuid: PropTypes.string,
  handleChangeAccess: PropTypes.func.isRequired,
  handleShareFile: PropTypes.func.isRequired,
};

FileHeaderShareButton.defaultProps = {
  shareUuid: null,
};

export default connect(null, mapDispatchToProps)(FileHeaderShareButton);
